import PropTypes from 'prop-types';
import classNames from 'clsx';
import css from './popover.module.scss';

export default function Popover({
  isOpen,
  className,
  children,
  pointerClassName,
  contentClassName,
}) {
  return (
    <div
      data-testid="popover-container"
      className={classNames(css.container, className, {
        [css.isClosed]: !isOpen,
      })}
    >
      <div
        data-testid="popover-content"
        className={classNames(css.content, contentClassName)}
      >
        {children}
      </div>
      <div
        data-testid="popover-pointer"
        className={classNames(css.pointer, pointerClassName)}
      />
    </div>
  );
}

Popover.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  pointerClassName: PropTypes.string,
  contentClassName: PropTypes.string,
};
